import { fallbackNode } from '../../../renderers/node/nodeRenderer';
export const getNodeComponent = (nodeAttributes, node) => {
    const { nodeType } = node;
    return nodeAttributes[nodeType] || fallbackNode;
};
